import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export const StatNumber = ({ value, suffix = "", duration = 2 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const end = value;
    const steps = 60;
    const inc = end / steps;
    const interval = (duration * 1000) / steps;
    const id = setInterval(() => {
      start += inc;
      if (start >= end) {
        setN(end);
        clearInterval(id);
      } else {
        setN(Math.floor(start));
      }
    }, interval);
    return () => clearInterval(id);
  }, [inView, value, duration]);

  return (
    <span ref={ref} className="font-display font-black tabular-nums">
      {n}
      {suffix}
    </span>
  );
};
